// Leitura do envelope de erro do backend para as telas de protocolo.
//
// O handler global responde { data: { code, message, erros: [...] } }; a tela precisa mostrar a
// mensagem e, quando houver, a lista de códigos que impediram a aprovação/importação.

export type ErroItemProtocolo = {
  caminho?: string
  codigoRegra?: string
  codigo?: string
  mensagem?: string
}

export type ErroProtocolo = {
  code?: string
  message: string
  erros: ErroItemProtocolo[]
  status?: number
}

const MENSAGEM_PADRAO = 'Não foi possível concluir a operação. Tente novamente.'

export const extrairErrosProtocolo = (erro: unknown): ErroProtocolo => {
  const resposta = (erro as { response?: { status?: number; data?: Record<string, unknown> } })
    ?.response
  const corpo = (resposta?.data?.data ?? resposta?.data ?? {}) as Record<string, unknown>
  const lista = Array.isArray(corpo.erros) ? (corpo.erros as ErroItemProtocolo[]) : []

  return {
    code: typeof corpo.code === 'string' ? corpo.code : undefined,
    message:
      (typeof corpo.message === 'string' && corpo.message) ||
      (erro as { message?: string })?.message ||
      MENSAGEM_PADRAO,
    erros: lista,
    status: resposta?.status,
  }
}

export const descreverErroItem = (item: ErroItemProtocolo): string =>
  [item.codigoRegra ?? item.caminho, item.codigo, item.mensagem].filter(Boolean).join(' — ')
